(function () {
  function initShowcase(el) {
    if (!el || el.dataset.swiperInit === "true") return;
    if (typeof Swiper === "undefined") return;

    const section = el.closest(".collection-showcase");
    if (!section) return;

    el.dataset.swiperInit = "true";

    function toggleScrollable(swiper) {
      // isLocked is true when all slides fit and there is nothing to scroll.
      section.classList.toggle("collection-showcase--scrollable", !swiper.isLocked);
    }

    new Swiper(el, {
      slidesPerView: "auto",
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: section.querySelector(".collection-showcase__prev"),
        nextEl: section.querySelector(".collection-showcase__next"),
      },
      pagination: {
        el: section.querySelector(".collection-showcase__progress"),
        type: "progressbar",
      },
      breakpoints: {
        640: { spaceBetween: 16 },
        750: { spaceBetween: 20 },
        990: { spaceBetween: 30 },
        1440: { spaceBetween: 30 },
      },
      on: {
        init: toggleScrollable,
        resize: toggleScrollable,
        breakpoint: toggleScrollable,
      },
    });

    section.classList.add("collection-showcase--ready");
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll(".collection-showcase__swiper")
      .forEach(initShowcase);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);

    // Related products / recommendations inject their markup via AJAX after
    // DOMContentLoaded, so watch for sliders added to the DOM later.
    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(".collection-showcase__swiper")) {
            initShowcase(node);
          }
          if (node.querySelectorAll) {
            initAll(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
